module.exports = __webpack_public_path__ + "static/media/Athena.eea51bc1.png";